import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import ImageUploader from "./ImageUploader";

const SliderItem = ({
  slider,
  setSliders,
  index,
  removeSlider,
  handleInputOnChange,
  removeImg,
}) => {
  const [selectedIcon, setSelectedIcon] = useState("");

  useEffect(() => {
    if (slider) {
      setSelectedIcon({ path: slider?.icon });
    }
  }, [slider]);
  return (
    <Row key={index}>
      <div className="add-multi-component">
        <Row style={{ rowGap: "10px" }}>
          <button
            type="button"
            onClick={() => removeSlider(index)}
            aria-label="Remove"
            className="removeImg"
          >
            <img src={removeImg} alt="" />
          </button>

          <Row>
            <Row>
              <Col lg={12} xs={12}>
                <div className="form-group required">
                  <h5>
                    <FormattedMessage id={"icon"} />
                  </h5>
                  <ImageUploader
                    selectedImage={selectedIcon}
                    setSelectedImage={setSelectedIcon}
                    slider={slider}
                    index={index}
                    setSliders={setSliders}
                    name={"icon"}
                  />
                </div>
              </Col>
              <Row>
                <Col lg={6} xs={12}>
                  <div className="form-group required">
                    <h5>
                      <FormattedMessage id={"description"} /> (
                      <FormattedMessage id="arabic-language" />)
                    </h5>
                    <input
                      type="title"
                      name="text.ar"
                      className="form-control form-outline"
                      onChange={(e) => handleInputOnChange(e, index)}
                      value={slider?.text?.ar}
                    />
                  </div>
                </Col>
                <Col lg={6} xs={12}>
                  <div className="form-group required">
                    <h5>
                      <FormattedMessage id={"description"} /> (
                      <FormattedMessage id="english-language" />)
                    </h5>
                    <input
                      type="title"
                      name="text.en"
                      className="form-control form-outline"
                      onChange={(e) => handleInputOnChange(e, index)}
                      value={slider?.text?.en}
                    />
                  </div>
                </Col>
              </Row>
            </Row>
          </Row>
        </Row>
      </div>
    </Row>
  );
};

export default SliderItem;
